import React, { Component } from "react";
import { Button, Col, Row } from "react-bootstrap";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import moment from "moment";
import _ from "lodash";

//Styles
import "./WhatsappInterest.scss";

//Images
import CSVdownload from "../../../resources/images/ic_download_csv.svg";
import PDFdownload from "../../../resources/images/ic_download_pdf.svg";

//Custom components
import SearchFilter from "../../CustomUIComponents/SearchFilter/SearchFilter.js";
import Pagination from "../../CustomUIComponents/Pagination/Pagination.js";
import UserModal from "../../CustomUIComponents/UserModal/UserModal.js";
import NotesModal from "../../CustomUIComponents/NotesModal/NotesModal.js";

//constants

import {
    SEARCH_FILTER_TYPE,
    SEARCH_FILTER_FIELDS,
    DATE_TYPE,
    DEFAULT_DATE_FORMAT,
    DEFAULT_DURATION,
    DEFAULT_LOAN_TYPE,
    DEFAULT_SALES_PERSON,
    USER_ROLES,
    INVOICE_DATE_FORMAT,
    DOWNLOAD_FILE_TYPE,
} from "../../../constants/appConstants.js";

import {
    DEFAULT_PAGINATION_RECORDS_COUNT,
    DEFAULT_PAGINATION_ACTIVE_PAGE,
} from "../../CustomUIComponents/Pagination/PaginationConstants.js";

import {
    FIRST_ROW_COLUMNS,
    LOAN_REQUEST_STATUSES,
    LOAN_STATUSES,
    SECOND_ROW_COLUMNS,
    WHATSAPP_INTEREST_REPORT_DOWNLOAD,
} from "../Constants.js";

//Utility
import Utility from "../../../utils/Utility.js";

//Strings
import { Strings } from "../../../resources/i18n/i18n.js";
import { LOAN_TYPE } from "../../DetailCommissionReport/Constants.js";

class WhatsappInterest extends Component {
    constructor(props) {
        super(props);
        this.columns = FIRST_ROW_COLUMNS;
        this.secondRow = SECOND_ROW_COLUMNS;
        this.state = {
            filters: {
                from: DEFAULT_DURATION.fromDate,
                to: DEFAULT_DURATION.toDate,
                status: LOAN_REQUEST_STATUSES[0].value,
                minimartId: "",
                loanType: "",
                salesPerson: "",
            },
            userList: props.userList,
            expanded: [],
            confirmationModalInformation: {
                show: false,
            },
            notesModal: false,

            //Pagination
            recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
            activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
        };
    }

    componentDidMount() {
        this.handleOnClickSearchFilter();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.userList, this.props.userList)) {
            this.setState({ userList: this.props.userList });
        }
        if (!_.isEqual(prevProps.rows, this.props.rows)) {
            this.setState({ rows: this.props.rows });
        }
    }

    handleSearchDateChange = (key) => (dateMoment) => {
        let DateValue = "";
        switch (key) {
            case DATE_TYPE.FROM_DATE:
                if (dateMoment.isAfter(this.state.filters.to)) {
                    DateValue = this.state.filters.from;
                } else {
                    dateMoment.set({ hour: 0, minute: 0, second: 0 });
                    DateValue = dateMoment.format(DEFAULT_DATE_FORMAT);
                }
                this.setState({
                    filters: {
                        ...this.state.filters,
                        from: DateValue,
                    },
                });
                break;
            case DATE_TYPE.TO_DATE:
                if (dateMoment.isBefore(this.state.filters.from)) {
                    DateValue = this.state.filters.to;
                } else {
                    DateValue = dateMoment.format(DEFAULT_DATE_FORMAT);
                }
                if (dateMoment.isAfter(new Date())) {
                    DateValue = new Date();
                }
                this.setState({
                    filters: {
                        ...this.state.filters,
                        to: DateValue,
                    },
                });
                break;
            default:
        }
    };

    handleOnClickSearchFilter = (isDefaultOffset = true) => {
        isDefaultOffset &&
            this.setState({
                activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
                expanded: [],
            });
        let searchFilterObject;
        searchFilterObject = {
            mid: this.state.filters.minimartId
                ? this.state.filters.minimartId
                : undefined,
            st: this.state.filters.status,
            lt:
                this.state.filters.loanType &&
                    this.state.filters.loanType !== DEFAULT_LOAN_TYPE
                    ? this.state.filters.loanType
                    : undefined,
            fd: this.state.filters.from
                ? Utility.convertDateIntoMiliSeconds(this.state.filters.from)
                : "",
            td: this.state.filters.to
                ? Utility.convertDateIntoMiliSeconds(this.state.filters.to)
                : "",
            sp: this.state.filters.salesPerson
                ? this.state.filters.salesPerson
                : undefined,
            lmt: this.state.recordsPerPage,
            off: isDefaultOffset
                ? DEFAULT_PAGINATION_ACTIVE_PAGE - 1
                : this.state.activePage - 1,
        };

        this.props.handleOnClickSearchFilter(searchFilterObject);
    };

    handleOnClickResetFilter = () => {
        this.setState(
            {
                filters: {
                    from: DEFAULT_DURATION.fromDate,
                    to: DEFAULT_DURATION.toDate,
                    minimartId: "",
                    status: LOAN_REQUEST_STATUSES[0].value,
                    loanType: "",
                    salesPerson: "",
                },
                expanded: [],
                userList: this.props.userList,

                //Pagination
                recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
                activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
            },

            this.handleOnClickSearchFilter
        );
    };

    handleOnChangeSelection = (event) => {
        this.setState({
            filters: {
                ...this.state.filters,
                [event.target.name]: event.target.value,
            },
        });
    };

    downloadFile = (fileType) => {
        // Backend (ReportDownloadController#downloadWhatsAppInterestsReport) reads the
        // filters as @RequestParam, so they must go on the query string, not the body.
        let downloadUrl =
            WHATSAPP_INTEREST_REPORT_DOWNLOAD.downloadUrl + "?fileType=" + fileType;
        if (this.state.filters.status) {
            downloadUrl += "&st=" + this.state.filters.status;
        }
        if (this.state.filters.salesPerson) {
            downloadUrl += "&sp=" + this.state.filters.salesPerson;
        }
        if (this.state.filters.minimartId) {
            downloadUrl += "&mid=" + this.state.filters.minimartId;
        }
        if (this.state.filters.from) {
            downloadUrl +=
                "&fd=" + Utility.convertDateIntoMiliSeconds(this.state.filters.from);
        }
        if (this.state.filters.to) {
            downloadUrl +=
                "&td=" + Utility.convertDateIntoMiliSeconds(this.state.filters.to);
        }
        // When the selected range exceeds 7 days the backend emails the report
        // instead of streaming a file (ReportDownloadController threshold).
        const rangeDays = moment(this.state.filters.to).diff(
            moment(this.state.filters.from),
            "days"
        );
        const isDownloadFile = rangeDays <= 7;
        this.props.downloadReports(downloadUrl, {}, fileType, isDownloadFile);
    };

    renderDownloadButtons = () => {
        return (
            <div className='pt-2 pe-4'>
                <Button
                    className='downloadButtons me-3'
                    onClick={() => this.downloadFile(DOWNLOAD_FILE_TYPE.PDF)}
                >
                    <img src={PDFdownload} alt='' />
                </Button>
                <Button
                    className='downloadButtons'
                    onClick={() => this.downloadFile(DOWNLOAD_FILE_TYPE.CSV)}
                >
                    <img src={CSVdownload} alt='' />
                </Button>
            </div>
        );
    };

    renderSearchFilter = () => {
        let userList = [DEFAULT_SALES_PERSON(), ...this.state.userList];

        let searchFilters = [
            {
                type: SEARCH_FILTER_TYPE.INPUT,
                handleOnChange: this.handleOnChangeSelection,
                Value: this.state.filters.minimartId,
                searchPlaceHolder: Strings("MatricesID"),
                fieldname: SEARCH_FILTER_FIELDS.MATRICES_ID,
                name: "minimartId",
                inputType: SEARCH_FILTER_TYPE.NUMBER,
                paddingBottom: true,
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleOnChangeSelection,
                Value: this.state.filters.status,
                fieldname: SEARCH_FILTER_FIELDS.STATUS,
                filterDropdownList: LOAN_REQUEST_STATUSES,
                name: "status",
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleOnChangeSelection,
                Value: this.state.filters.loanType,
                fieldname: SEARCH_FILTER_FIELDS.LOAN_TYPE,
                filterDropdownList: LOAN_TYPE,
                name: "loanType",
            },

            {
                type: SEARCH_FILTER_TYPE.DATE,
                handleOnChange: this.handleSearchDateChange,
                fromDate: this.state.filters.from,
                handleCalenderChange: this.handleSearchDateChange,
                toDate: this.state.filters.to,
                fieldname: SEARCH_FILTER_FIELDS.DATE,
                column: 4,
            },
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.handleOnChangeSelection,
                Value: this.state.filters.salesPerson,
                fieldname: SEARCH_FILTER_FIELDS.SALES_PERSON,
                filterDropdownList: userList,
                name: "salesPerson",
            },
        ];
        return (
            <SearchFilter
                filters={searchFilters}
                handleOnClickSearchFilter={this.handleOnClickSearchFilter}
                handleOnClickResetFilter={this.handleOnClickResetFilter}
                paddingLeft={2}
                paddingTop={2}
            />
        );
    };

    onPageChange = ({ page, pageLength }) => {
        this.setState(
            {
                activePage: page,
                recordsPerPage: pageLength,
            },
            () => this.handleOnClickSearchFilter(false)
        );
    };

    handleExpandClick = (id) => {
        let expandIndexId = this.state.expanded;
        const index = expandIndexId.indexOf(id);
        expandIndexId.includes(id)
            ? expandIndexId.splice(index, 1)
            : expandIndexId.push(id);
        this.setState({
            expanded: expandIndexId,
        });
    };

    toggleModal = () => {
        this.setState(
            {
                note: "",
                notesModal: !this.state.notesModal,
            },
            () => {
                this.handleOnClickSearchFilter(false);
            }
        );
    };

    addNote = (note) => {
        this.setState(
            {
                note: note,
            },
            () => {
                this.props.updateLoanRequest(
                    {
                        nt: this.state.note,
                        id: this.state.reqId,
                        mid: this.state.minimartId,
                        rt: "DISMISSED",
                    },
                    this.toggleModal
                );
            }
        );
    };

    onDaySelection = (dayObject) => {
        let date = Utility.daySelectionForSellerAssignment(dayObject.day)
        this.setState({ date });
    };

    renderConfirmationModal = () => {
        return (
            <UserModal
                open={this.state.confirmationModalInformation.show}
                modalCloseOnEsc={false}
                modalCloseOnOverlayClick={false}
                modalShowCloseIcon={false}
                headerText={this.state.confirmationModalInformation.type}
                modalText1={this.state.confirmationModalInformation.text}
                modalButtonOk={{
                    text: Strings("Set"),
                    onClick:
                        this.state.confirmationModalInformation.onClickOkCallback,
                }}
                modalButtonCancel={{
                    text: Strings("Cancel"),
                    onClick:
                        this.state.confirmationModalInformation
                            .onClickCancelCallback,
                }}
                showHr={true}
                handleRadioChange={this.onDaySelection}
                note={Strings("visitNote")}
            />
        );
    };

    closeConfirmationModal = () => {
        this.setState({
            confirmationModalInformation: {
                show: false,
            },
        });
    };

    handleYesClick = (minimartId, reqId) => {
        this.closeConfirmationModal();
        this.props.updateLoanRequest(
            {
                mid: minimartId,
                id: reqId,
                ad: Utility.convertDateIntoMiliSeconds(this.state.date),
                rt: "ASSIGNED",
            },
            this.handleOnClickSearchFilter
        );
    };

    assignSalesPerson = (minimartId, reqId) => {
        return this.setState({
            confirmationModalInformation: {
                type: Strings("salesPersonAssignment"),
                show: true,
                text: Strings("assignSalesPerson"),
                onClickOkCallback: () =>
                    this.handleYesClick(minimartId, reqId),
                onClickCancelCallback: this.closeConfirmationModal,
            },
        });
    };

    onDeleteClick = (minimartId, reqId) => {
        this.setState({
            notesModal: true,
            reqId: reqId,
            minimartId: minimartId,
        });
    };

    buttonCondition = (row, loan) => {
        if (
            row["st"] === LOAN_STATUSES.VISITED ||
            row["st"] === LOAN_STATUSES.ASSIGNED ||
            row["st"] === LOAN_STATUSES.PENDING
        ) {
            return (
                <Row>
                    <Col
                        className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? 'cursorDisabled px-0'
                            : 'cursorPointer px-0'}
                        onClick={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? () => { }
                            : () => this.onDeleteClick(row.mid, loan.id)}
                    >
                        {this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? <i
                                className='px-1 fa fa-ban'
                                aria-hidden='true'
                                title='Eliminar Subtipo'
                            />
                            : <i
                                className='px-1 fa fa-trash'
                                aria-hidden='true'
                                title='Eliminar Subtipo'
                            />}
                        <span className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? "content url"
                            : "content url textColor"}>
                            {Strings("Delete")}
                        </span>
                    </Col>
                </Row>
            );
        } else if (row["st"] === LOAN_STATUSES.DISMISSED) {
            return null;
        }
    };

    assignButton = (row) => {

        // PENDING: show schedule visit and delete button
        if (row["st"] === LOAN_STATUSES.PENDING) {
            return (
                <Row>
                    <Col
                        className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? 'cursorDisabled px-0 d-flex justify-content-end align-center'
                            : 'cursorPointer px-0 d-flex justify-content-end align-center'}
                        onClick={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? () => { }
                            : () => this.assignSalesPerson(row.mid, row.loan?.id || row.id)}
                        md={6}
                        title={Strings("resolveLoanRequestNotAllowed")}
                    >
                        {this.props.loggedInUser.role !== USER_ROLES.salesManager
                            ? <i className='px-1 fa fa-user ' />
                            : <i className='px-1 fa fa-ban ' />}

                        <span className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? "content url disabled"
                            : "content url textColor"}>
                            Programar visita
                        </span>
                    </Col>
                    <Col
                        className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? 'cursorDisabled px-0 d-flex justify-content-start align-center'
                            : 'cursorPointer px-0 d-flex justify-content-start align-center'}
                        onClick={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? () => { }
                            : () => this.onDeleteClick(row.mid, row.loan?.id || row.id)}
                        md={6}
                    >
                        {this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? <i
                                className='px-1 fa fa-ban'
                                aria-hidden='true'
                                title='Eliminar Subtipo'
                            />
                            : <i
                                className='px-1 fa fa-trash'
                                aria-hidden='true'
                                title='Eliminar Subtipo'
                            />}
                        <span className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? "content url"
                            : "content url textColor"}>
                            {Strings("Delete")}
                        </span>
                    </Col>
                </Row>
            );
        }

        // VISITED: no button
        if (row["st"] === LOAN_STATUSES.VISITED) {
            return null;
        }


        // ASSIGNED: only delete button
        if (row["st"] === LOAN_STATUSES.ASSIGNED) {
            return (
                <Row>
                    <Col
                        className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? 'cursorDisabled px-0 d-flex justify-content-center align-center'
                            : 'cursorPointer px-0 d-flex justify-content-center align-center'}
                        onClick={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? () => { }
                            : () => this.onDeleteClick(row.mid, row.loan?.id || row.id)}
                        md={12}
                    >
                        {this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? <i
                                className='px-1 fa fa-ban'
                                aria-hidden='true'
                                title='Eliminar Subtipo'
                            />
                            : <i
                                className='px-1 fa fa-trash'
                                aria-hidden='true'
                                title='Eliminar Subtipo'
                            />}
                        <span className={this.props.loggedInUser.role === USER_ROLES.salesManager
                            ? "content url"
                            : "content url textColor"}>
                            {Strings("Delete")}
                        </span>
                    </Col>
                </Row>
            );
        }

        return null;

    };


    renderLoanRequestList = (rows, columns) => {

        const loanRows = [];
        rows.forEach((row) => {
            row.lns.forEach((loan) => {
                loanRows.push({
                    ...row,
                    loan: loan,
                });
            });
        });

        // Check if any row has buttons (to conditionally show Action header)
        const hasActionButtons = loanRows.some(loanRow => {
            const status = loanRow["st"];
            return status === LOAN_STATUSES.PENDING || status === LOAN_STATUSES.ASSIGNED;
        });
        const hasNoteButtons = loanRows.some(loanRow => {
            const status = loanRow["st"];
            return status === LOAN_STATUSES.DISMISSED;
        })

        return (
            <div className='mx-5'>
                <Card className={"mt-3 headerRow py-2"}>
                    <CardActions disableSpacing>
                        {columns.map((column) => {
                            return (
                                <Col
                                    md={column.key === "mn" ? 3 : column.key === "mid" ? 1 : 2}
                                    className={"text-center"}
                                    key={Strings(column.name)}
                                >
                                    <Typography className={"headerContent"} title={Strings(column.name)}>
                                        {Strings(column.name)}
                                    </Typography>
                                </Col>
                            );
                        })}
                        <Col md={2} className={"text-center"}>
                            <Typography className={"headerContent"} title={Strings("dateOfInterest")}>
                                {Strings("dateOfInterest")}
                            </Typography>
                        </Col>
                        {hasNoteButtons && (
                            <Col md={2} className={"text-center text-start text-break"}>
                                <Typography className={"headerContent"} title={Strings("Notes")}>
                                    {Strings("Notes")}
                                </Typography>
                            </Col>
                        )}
                        {hasNoteButtons && (
                            <Col md={2} className={"text-center"}>
                                <Typography className={"headerContent"} title={Strings("firedFor")}>
                                    {Strings("firedFor")}
                                </Typography>
                            </Col>
                        )}
                        {hasActionButtons && (
                            <Col md={3} className={"text-center"}>
                                <Typography className={"headerContent"} title={Strings("action")}>
                                    {Strings("action")}
                                </Typography>
                            </Col>
                        )}
                    </CardActions>
                </Card>
                {loanRows.map((loanRow, index) => {
                    const status = loanRow["st"];
                    const showActionColumn = status === LOAN_STATUSES.PENDING ||
                        status === LOAN_STATUSES.ASSIGNED;
                    const showNoteColumn = status === LOAN_STATUSES.DISMISSED;
                    return (
                        <Card
                            key={index}
                            className={"tableRow py-1"}
                            style={{ backgroundColor: "#FAFAFA" }}
                        >
                            <CardActions>
                                {columns.map((column) => {
                                    return (
                                        <Col
                                           md={column.key === "mn" ? 3 : column.key === "mid" ? 1 : 2}
                                            className={"text-center ms-0"}
                                            title={Strings(column.name)}
                                            key={Math.random()}
                                        >
                                            <Typography className={"content"} title={Strings(loanRow[column.key])}>
                                                {Strings(loanRow[column.key])}
                                            </Typography>
                                        </Col>
                                    );
                                })}
                                <Col md={2} className={"text-center ms-0"}>
                                    <Typography className={"content"} title={loanRow.loan.cd ? moment(loanRow.loan.cd).format(INVOICE_DATE_FORMAT) : ""}>
                                        {loanRow.loan.cd &&
                                            moment(loanRow.loan.cd).format(INVOICE_DATE_FORMAT)}
                                    </Typography>
                                </Col>
                                {showNoteColumn && (
                                    <Col md={2} className={"text-center ms-0 text-start text-break"}>
                                        <Typography className={"content"} title={Strings(loanRow.loan?.nt || "")}>
                                            {Strings(loanRow.loan?.nt || "")}
                                        </Typography>
                                    </Col>
                                )}
                                {showNoteColumn && (
                                    <Col md={2} className={"text-center ms-0"}>
                                        <Typography className={"content"} title={Strings(loanRow.loan?.db || "")}>
                                            {Strings(loanRow.loan?.db || "")}
                                        </Typography>
                                    </Col>
                                )}
                                {showActionColumn && (
                                    <Col md={3} className={"text-end ms-0"} >
                                        <Typography className={"content"}>
                                            {this.assignButton(loanRow)}
                                        </Typography>
                                    </Col>
                                )}
                            </CardActions>
                        </Card>
                    );
                })}
            </div>
        );
    };

    render() {
        return (
            <>
                {this.state.confirmationModalInformation.show &&
                    this.renderConfirmationModal()}
                {this.state.notesModal && (
                    <NotesModal
                        open={this.state.notesModal}
                        note={this.state.note}
                        modalHeader={Strings("Notes")}
                        toggleModal={this.toggleModal}
                        isNotesCompulsory={true}
                        maxLength={500}
                        addNote={this.addNote}
                        noteType={this.state.noteType}
                    />
                )}

                <div className='greyback customTableCard'>
                    {this.renderSearchFilter()}
                    <Row>
                        <Col
                            md={{ span: 2, offset: 10 }}
                            className='pull-right alignDownloadButtons'
                        >
                            {this.renderDownloadButtons()}
                        </Col>
                    </Row>
                    {this.state.rows?.length > 0 ? (
                        <>
                            {this.renderLoanRequestList(
                                this.state.rows,
                                this.columns
                            )}
                            <Col md={12} className='noPadding alignPagination'>
                                <Pagination
                                    activePage={this.state.activePage}
                                    recordsPerPage={this.state.recordsPerPage}
                                    numberOfPages={this.props.numberOfPages}
                                    onPageChange={this.onPageChange}
                                    dropup={true}
                                />
                            </Col>
                        </>
                    ) : (
                        <div className='noRecordsFound'>
                            {Strings("NoRecordsFound")}
                        </div>
                    )}
                </div>
            </>
        );
    }
}

export default WhatsappInterest;